module.exports = __webpack_public_path__ + "img/list.92f21e12.png";